import { Dialog, List } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

export const StyledList = styled(List)`
  list-style-type: disc;
  padding-top: 0;
  padding-bottom: 0;

  .MuiListItem-root {
    display: list-item;
    list-style-position: inside;
    &::marker {
      margin-right: 0;
    }
    padding: 0;
  }
`;

export const StyledMigratedDubbingDialog = styled(Dialog)`
  .dialog-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 48px 24px 48px;
  }

  .MuiDialog-paper {
    border-radius: 16px;
  }

  min-width: ${(props) => props.width || 'auto'};

  .dialog-title {
    text-align: center;
  }

  .title {
    text-align: center;
    color: ${COLOR.darkGray};
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    word-wrap: break-word;
  }

  .message {
    color: rgba(28, 28, 30, 0.64);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
  }

  .conversion-info {
    color: ${COLOR.darkGray};
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
    font-size: 16px;
  }

  .highlight {
    font-weight: bold;
    color: #007bff;
  }

  .conversion-rate {
    font-size: 14px;
    color: rgba(28, 28, 30, 0.64);
    font-style: italic;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    margin-top: -16px;
  }

  .details-box {
    background-color: #e6f7ff;
    padding: 16px;
    border-radius: 8px;
    text-align: left;
  }

  .migrate-title {
    color: ${COLOR.darkGray};
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
    font-size: 16px;
    margin-bottom: 4px;
  }

  .migrate-info {
    color: rgba(28, 28, 30, 0.64);
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
  }

  .new-characters {
    align-items: center;
  }

  .package-preserver-date,
  .new-characters,
  .package-expiry-date {
    font-size: 14px;
    font-weight: 400;
  }

  .package-expiry-date {
    margin-top: 8px;
  }

  .expired {
    color: #ff3b30;
    margin-top: 8px;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 400;
  }

  .lock-icon {
    color: ${COLOR.red};
    cursor: pointer;
    font-size: 16px;
    margin-left: 4px;
    margin-bottom: -2px;
  }

  .button-agree {
    display: flex;
    justify-content: center;
  }

  .button {
    width: fit-content;
    text-transform: none;
    border-radius: 12px;
    color: ${COLOR.darkBlue};
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
    word-wrap: break-word;
    padding: 12px 32px;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .dialog-container {
      padding: 16px;
    }
    .message {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
`;
